import React, { useEffect, useState } from 'react';
import RandomPreview from './RandomPreview';
import ChatInterface from './ChatInterface';
import PreviewModal from './PreviewModal';

const INTRO_COOLDOWN_MS = 10 * 60 * 1000;
const INTRO_LAST_SEEN_KEY = 'aayushIntroLastSeenAt';

const shouldShowIntro = () => {
  try {
    const lastSeenAt = Number(localStorage.getItem(INTRO_LAST_SEEN_KEY) || 0);
    return !lastSeenAt || Date.now() - lastSeenAt > INTRO_COOLDOWN_MS;
  } catch (error) {
    return true;
  }
};

const HomePage = () => {
  const [showIntro, setShowIntro] = useState(() => shouldShowIntro());
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!showIntro) return;

    try {
      localStorage.setItem(INTRO_LAST_SEEN_KEY, String(Date.now()));
    } catch (error) {
      // Ignore storage failures; the intro should still work.
    }
  }, [showIntro]);

  const handleRandomPreviewComplete = () => {
    setShowIntro(false);
    try {
      const hasVisited = localStorage.getItem('hasVisitedAayushChat');
      if (!hasVisited) {
        setShowModal(true);
        localStorage.setItem('hasVisitedAayushChat', 'true');
      }
    } catch (error) {
      setShowModal(true);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleModalPrimary = () => {
    setShowModal(false);
  };

  return (
    <div>
      {showIntro ? (
        <RandomPreview onComplete={handleRandomPreviewComplete} />
      ) : (
        <>
          <ChatInterface />
          {showModal && (
            <PreviewModal 
              onClose={handleModalClose} 
              onPrimary={handleModalPrimary}
            />
          )}
        </>
      )}
    </div>
  );
};

export default HomePage;
